import React from 'react';
import {Carousel} from 'react-responsive-carousel';
import CommunityImg from '../CommunityImg/CommunityImg';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import './Carousal.scss';

const Carousal = ({
  imgArr
}) => {

  return (
    <Carousel 
      showArrows={true} 
      onChange={()=>{}} 
      onClickItem={()=>{}} 
      onClickThumb={()=>{}}
      showIndicators={false}
      statusFormatter={()=>{}}
      swipeable={true}
      >
        {
          imgArr.map(img => (
            <img className="carousal-img" src={img} />
          ))
        }
    </Carousel>
  )
}

export default Carousal;